<template>
    <div class="footer_bg">
        <div class="footer">
            <div class="footer_list">
                <ul class="vision">
                    <li>解决方案</li>
                    <li>线上云展会</li>
                    <li>企业展厅</li>
                    <li>3D产品建模</li>
                    <li>VR艺术画展</li>
                    <li>党建文博物展馆</li>
                    <li>地产房产宣传</li>
                </ul>
                <ul class="Contact_WM">
                    <li>业务范围</li>
                    <li>VR展厅漫游</li>
                    <li>3D产品展示</li>
                    <li>VR场景购</li>
                    <li>展会VR直播</li>
                    <li>房产VR沙盘</li>
                    <li>房产动画视频</li>
                </ul>
                 <ul class="About_us">
                    <li @click="coord">关于我们</li>
                    <li @click="coord">公司简介</li>
                    <li @click="coord">发展历程</li>
                    <li @click="coord">企业文化</li>
                    <li @click="coord">荣誉资质</li>
                </ul>
                <ul class="business">
                    <li>联系我们</li>
                    <li>
                        客服电话
                        <h4>{{info.phone}}</h4>
                    </li>
                    <li>
                        电子邮箱
                        <h4>{{info.email}}</h4>
                    </li>
                    <li>详细地址
                          <h4>{{info.address}}</h4>
                    </li>
                </ul>
                 <ul class="contact">
                    <li>
                        <img src="../../assets/imges/footer1.png"/>
                        <h5>欢迎关注官方微信</h5>
                    </li>
                    <li>
                        <img src="../../assets/imges/footer2.png"/>
                        <h5>欢迎关注官方小程序</h5>
                    </li>
                </ul>
            </div>
        </div>
           <div class="footer_h5">
               <a href="http://beian.miit.gov.cn/">Copyright©2020 {{info.company_name}}  All Rights Reserved {{info.ICP}}</a>
            </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            info:''
        }
    },
    created(){
        this.getinfo()
    },
    methods:{
        //跳到关于我们
        coord(){
            this.$router.push({
                path: `/coordinates`

            })
        },

        getinfo(){
        this.$axios.get("https://3dyunchuang.com/api/test/getaboutcontent",)
            .then(response => {            
                this.info = response.data.data[0]
            }
        )   
        
        }
    }
}
</script>
<style scoped>
.footer_bg{
    width: 100%;
    height: 393px;
    background: #2e323b;
}
.footer{
    width: 1202px;
    height: 100%;
    margin: 0 auto;
    
}
.footer_list{
    float: left;
    margin-top: 46px;
    width: 100%;
    height: 240px;
}
.vision{
    width: 167px;
    float: left;
}
.vision li:nth-child(1){
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    height: 33px;
    margin-bottom: 22px;
}
.footer_list li{
    font-size: 14px;
    margin-bottom: 22px;
    color: #babfc5;
    cursor: pointer;
}
.footer_list li:hover{
    color: #23b5fa;
}
.Contact_WM{
    width: 165px;
    float: left;
}
.Contact_WM li:nth-child(1){
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    height: 33px;
    margin-bottom: 22px;
}
.contact{
    width: 376px;
    height: 168px;
    float: left;
}
.contact li{
    float: left;
    width: 164px;
    height: 188px;
    margin-right: 48px;
}
.contact li img{
    width: 100%;
    height: 162px;
}
.contact li:nth-child(2){
    margin: 0;
}
.contact li h5{
    margin-top: 10px;
    text-align: center;
    font-weight: normal;
}

.footer_h5{
    width: 100%;
    height: 53px;
    line-height: 53px;
    color: #fff;
    font-size: 14px;
    background: #18191d;
    text-align: center;
}
.About_us{
    float: left;
    width: 170px;
}
.About_us li:nth-child(1){
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    height: 33px;
    margin-bottom: 22px;
}
.business{
    float: left;
    width: 319px;
}
.business li{
    cursor: default;
}
.business li h4{
    margin-top: 3px;
}
.business li:nth-child(1){
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    height: 33px;
    margin-bottom: 22px;
}
.business li:hover{
    color: #babfc5;
}
.business li:nth-child(3) h4{
 font-size: 16px;
}
.business li:nth-child(4) h4{
 font-size: 16px;

}
.business h4{
    font-size: 20px;
    color:#358aff;
    font-weight: 500;
}
.footer_h5 a{
    cursor: pointer;
    color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/common/index/pahe-footer.vue